<template>
    <div class="fluid">
        <h1 class="app-title">Cadastro de Percentual Mensal</h1>
        <b-card :title="indice != null ? indice.descricao + ' - ' + indice.tipoIndice : ''">
            <b-row class="mb-0">
                <b-col sm="12" md="2">
                    <b-form-group
                            label="Variação Índice (%):"
                            label-for="variacao"
                            class="text-label required">
                        <b-form-input 
                                    v-model="indice.variacaoIndice" 
                                    type="text" id="variacao"
                                    @keyup="indice.variacaoIndice = formatarDecimal(indice.variacaoIndice, 3, 4)"
                                    :class="'text-label required ' + (!validations.variacaoIndice.valid ? 'is-invalid' : '')">
                      </b-form-input> 
                     <div v-if="!validations.variacaoIndice.valid" class="invalid-message">{{validations.variacaoIndice.message}}</div>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mt-1 mb-0">
                <b-col sm="12" md="2">
                    <b-form-group
                            label="Mês:"
                            label-for="mes"
                            class="text-label required">
                           
                        <b-form-input
                                type="text"
                                id="mes"
                                v-model="indice.mes"
                                v-mask="['##']"
                                @change="validarMes()"
                                :class="'text-label required ' + (!validations.mes.valid ? 'is-invalid' : '')">
                        </b-form-input>
                        <div v-if="!validations.mes.valid" class="invalid-message">{{validations.mes.message}}</div>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mt-1 mb-0">
                <b-col sm="12" md="2">
                    <b-form-group
                            label="Ano:"
                            label-for="ano"
                            class="text-label required">
                        <b-form-input
                                type="text"
                                id="ano"
                                v-model="indice.ano"
                                v-mask="['####']"
                                :class="'text-label required ' + (!validations.ano.valid ? 'is-invalid' : '')">
                        </b-form-input>
                         <div v-if="!validations.ano.valid" class="invalid-message">{{validations.ano.message}}</div>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-card>
        <b-modal
                id="modal-voltar"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Voltar"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p style="font-weight: bold;">Deseja retornar à tela anterior sem salvar o cadastro ou as alterações?</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-voltar')"> Não</b-button>
                <b-button variant="primary" @click="voltar"> Sim</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-salvar"
                id="modal-salvar"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Salvar"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p style="font-weight: bold;" v-if="!existeRegistro">Para o mês/ano imediatamente anterior ao informado nos campos “Mês” e “Ano” não consta registro de variação cadastrada no sistema para o índice em questão. Dessa forma, antes de realizar o cadastro da variação do índice para o mês informado, retorne à tela anterior e efetue o cadastro da variação do índice relativo ao mês/ano anterior.</p>
                    <p style="font-weight: bold;" v-if="existeRegistro">Para o mês/ano informado nos campos “Mês” e “Ano” já consta registro de variação cadastrada no sistema para o índice em questão. Ao confirmar esse novo cadastrado, a variação anteriormente cadastrada para o mês/ano informado será substituída pela variação informada.</p>
                    <p style="font-weight: bold;" v-if="existeRegistro">Deseja confirmar a alteração da variação do índice para o mês/ano informado?</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-salvar')" v-if="!existeRegistro"> Voltar</b-button>
                <b-button variant="secondary" @click="hide('modal-salvar')" v-if="existeRegistro"> Não</b-button>
                <b-button variant="primary" @click="salvar" v-if="existeRegistro"> Sim</b-button>
            </template>
        </b-modal>
        <hr class="mt-2"/>
        <b-row class="center-xy">
            <b-button variant="outline-secondary" v-b-modal.modal-voltar>
                <i class="fa fa-reply"></i> Voltar
            </b-button>
            <b-button variant="primary" class="ml-2" @click="verificarSalvar">
                <i class="far fa-save"></i> Salvar
            </b-button>
        </b-row>
        <CompLoading ref="loading"/>
    </div>
</template>
<script>
    import Multiselect from 'vue-multiselect'
    import axios from 'axios'
    import formatarMixins from '../../mixins/formatarMixins'
    import CompLoading from "../shared/components/CompLoading";

    export default {
        components: {CompLoading, Multiselect},
        mixins: [ formatarMixins ],
        data() {
            return {
                indice: {
                    ano: null,
                    mes: null,
                    variacaoIndice: null
                },
                existeRegistro: false,
                validations: {
                    variacaoIndice: {valid: true, message: ''},
                    mes: {valid: true, message: ''},
                    ano: {valid: true, message: ''}
                },
            }
        },
        methods: {
            validarMes(){
                if(this.indice.mes != null && this.indice.mes.length > 0){
                    let mesInteiro = parseInt(this.indice.mes);
                
                    if(mesInteiro < 1  || mesInteiro > 12){
                        this.adicionarErroDeValidacao(this.validations.mes, "Mês inválido!");
                    }else{
                       this.limparErroDeValidacao(this.validations.mes);
                    }
                }else{
                    this.limparErroDeValidacao(this.validations.mes);
                }
            },
            
            verificarSalvar() {
                if(!this.verificarObrigatoriedade()) {
                    return;
                }

                let verificarIndice = {
                    codIndice: this.indice.codIndice,
                    ano: this.indice.ano,
                    mes: this.indice.mes,
                    variacaoIndice: this.indice.variacaoIndice.replace(",", ".")
                };

                this.$refs.loading.showLoading();
                axios.post(`${this.urlApi}/v1/indice/verificarExistenciaHistorico`, verificarIndice, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    if(response.data == 2) {
                        this.existeRegistro = true;
                        this.$refs.loading.hideLoading();
                        this.$refs['modal-salvar'].show();
                        return;
                    } else if(response.data == 1) {
                        this.existeRegistro = false;
                        this.$refs.loading.hideLoading();
                        this.$refs['modal-salvar'].show();
                        return;
                    }
                    this.salvar();
                }).catch((error) => {
                    this.exibirErro(error);
                    this.$refs.loading.hideLoading();
                });
            },

            salvar() {
                this.$refs['modal-salvar'].hide();

                this.indice.variacaoIndice = this.indice.variacaoIndice.replace(",", ".");

                this.$refs.loading.showLoading();
                axios.post(`${this.urlApi}/v1/indice/salvar`, this.indice, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.$store.commit("setMsgCrud", 'Operação realizada com sucesso!!!');
                    this.$router.push({path: '/indice'});
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.$refs.loading.hideLoading();
                });
            },

            verificarObrigatoriedade() {
                this.validarCamposObrigatorios(this.indice, this.validations);
                
                if(this.validations.mes.valid){
                    this.validarMes();
                }
                
                return !this.validationsContainsError(this.validations);
            },

            voltar(evt) {
                evt.preventDefault();
                this.$router.push({path: '/indice'});
            },
        },
        computed: {
            getTheme () {
                return this.$store.getters.getTheme
            }
        },
        mounted() {
            this.$store.commit("setMessages", {});
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;

            this.indice = this.$store.getters.getIndice;
        }
    }
</script>
<style>
    .multiselect-simple .multiselect__content-wrapper .multiselect__content .multiselect__element span:before {
        display: none;
    }
</style>